/**
 * 
 */
import Util, {
  mutationObserver,
  resizeObserver,
  curryDebounce,
} from '../../util/index.js';
export default class Context {
  constructor(args) {
    const {ele, data} = args;
    this.ele = Util.isString(ele) ? document.querySelector(ele) : ele;
    this.data = data;
    this.dpr = 2;
    if (this.ele.tagName.toUpperCase() === 'CANVAS') {
      this.canvas = this.ele;
      this.context = this.ele.getContext('2d');
    } else {
      this._createContext();
    }
    this.contentRect = {
      left: 0,
      top: 0,
      width: 0,
      height: 0,
    };
    this.resizeObserve = resizeObserver(curryDebounce(this._resize, this, 50));
    this.resizeObserve.observe(this.ele);
  }
  _createContext() {
    const canvas = document.createElement('canvas');
    this.canvas = canvas;
    this.context = canvas.getContext('2d');
    this.ele.appendChild(canvas);
  }
  _resize({contentRect}) {
    let {width, height} = contentRect;
    if (width === 0 || height === 0) {
      this.destroy();
    } else {
      const canvas = this.canvas;
      if (this.ele !== this.canvas) {
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
      } else {
        const style = window.getComputedStyle(this.ele);
        width = parseInt(style.width);
        height = parseInt(style.height);
      }
      this.contentRect = {
        ...this.contentRect,
        width: width * this.dpr,
        height: height * this.dpr,
      };
      canvas.width = width * this.dpr;
      canvas.height = height * this.dpr;
      this.draw();
    }
  }
  init() {}
  draw() {}
  destroy() {
    if (this.resizeObserve) {
      this.resizeObserve.unobserve(this.ele);
      this.resizeObserve = null;
    }
    if (this.canvas && this.canvas.parentNode === this.ele) {
      this.ele.removeChild(this.canvas);
    };
    this.canvas = null;
    this.ele = null;
  }
}
